module.exports = __webpack_public_path__ + "img/about_us_3.7a2a1c77.jpg";